"use client";
import { useDocumentDirection } from "@/hooks/useDocumentDirection";
import { chunkData } from "@/utils/utils";
import Image from "next/image";

const HowVirtualCardWorks = ({ data }) => {
  const dir = useDocumentDirection();

  const stepColors = [
    {
      cardBg: "#9672FF",
    },
    {
      cardBg: "#3B9797",
    },
    {
      cardBg: "#3396D3",
    },
    {
      cardBg: "#9672FF",
    },
    {
      cardBg: "#3B9797",
    },
    {
      cardBg: "#3396D3",
    },
  ];

  const isConnectorVisible = (index) => {
    const adjustedIndex = dir === "rtl" ? index - 1 : index;
    const showOnMd = adjustedIndex >= 0 && (adjustedIndex + 1) % 2 !== 0;
    const showOnLg = adjustedIndex >= 0 && (adjustedIndex + 1) % 3 !== 0;
    return { showOnMd, showOnLg };
  };

  return (
    <div className="section_space_py">
      <div className="custom-container mx-auto">
        <div className="border-2 border-[rgba(116,69,255,0.16)] p-[30px] xl:p-[55px] rounded-[30px] virtual-card-box-shadow">
          <div className="mb-10 md:mb-[60px]">
            <h2 className="title-design text-center mb-4">How It Works</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7.5">
            {chunkData(data)?.map((group, rowIndex) => (
              <div key={rowIndex} className="contents">
                {group.map((item, index) => {
                  const realIndex = rowIndex * 3 + index;
                  const currentColor = stepColors[realIndex]?.cardBg;
                  const nextColor = stepColors[realIndex + 1]?.cardBg;
                  const { showOnMd, showOnLg } = isConnectorVisible(realIndex);

                  return (
                    <div key={realIndex} className="relative">
                      <div className="flex flex-col items-center">
                        <div
                          className="w-[70px] md:w-[90px] h-[70px] md:h-[90px] rounded-2xl md:rounded-[20px] flex items-center justify-center mb-3 md:mb-12"
                          style={{ backgroundColor: currentColor }}
                        >
                          <Image
                            src={item?.icon}
                            alt="virtual card"
                            width={100}
                            height={100}
                            className="w-[30px] h-[30px] object-cover"
                          />
                        </div>

                        <div className="flex flex-col items-center">
                          <h3 className="heading-design text-center mb-3 md:mb-5">
                            {item?.title}
                          </h3>
                          <p className="text-[14px] md:text-[15px] font-medium text-user-paragraph text-center w-full md:w-[95%]">
                            {item?.description}
                          </p>
                        </div>
                      </div>

                      {nextColor && (
                        <div
                          className={`absolute top-[35px] ltr:start-[105%] rtl:end-[105%] w-[57%] h-[2px] -translate-x-1/2 hidden ${showOnMd ? "md:block" : "md:hidden"} ${showOnLg ? "lg:block" : "lg:hidden"}`}
                        >
                          <div className="relative w-[155px] xl:w-[175px] 2xl:w-[200px] h-[20px]">
                            <span
                              className="absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-2.5 h-2.5 rounded-full"
                              style={{ backgroundColor: currentColor }}
                            />
                            <span className="absolute left-[10px] right-[10px] top-1/2 -translate-y-1/2 h-[2px] bg-[linear-gradient(to_right,#a0a0a0_50%,transparent_50%)] bg-[length:16px_2px] bg-repeat-x" />
                            <span
                              className="absolute ltr:right-0 rtl:left-0 top-1/2 -translate-y-1/2 w-2.5 h-2.5 rounded-full"
                              style={{ backgroundColor: nextColor }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowVirtualCardWorks;
